import { render, staticRenderFns } from "./tableRelatorioGecomPromotor.vue?vue&type=template&id=d227e09c&scoped=true&"
import script from "./tableRelatorioGecomPromotor.vue?vue&type=script&lang=js&"
export * from "./tableRelatorioGecomPromotor.vue?vue&type=script&lang=js&"
import style0 from "./tableRelatorioGecomPromotor.vue?vue&type=style&index=0&id=d227e09c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d227e09c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VSkeletonLoader,VTooltip})
